import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { logError } from "@/lib/errorLogger";


const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const pathname = location.pathname;
    
    // Check for double-encoded URLs first (%25 indicates % was encoded)
    if (pathname.includes('%25')) {
      try {
        const doubleDecoded = decodeURIComponent(decodeURIComponent(pathname));
        console.log(`[NotFound] Detected double-encoded URL, redirecting from "${pathname}" to "${doubleDecoded}"`);
        setIsRedirecting(true);
        navigate(doubleDecoded, { replace: true });
        return;
      } catch (e) {
        // Fall through to single decode attempt
      }
    }
    
    // Check if URL contains encoded query string characters (%3F = ?, %3D = =, %26 = &)
    if (pathname.includes('%3F') || pathname.includes('%3D') || pathname.includes('%26')) {
      try {
        const decodedPath = decodeURIComponent(pathname);
        console.log(`[NotFound] Detected encoded URL, redirecting from "${pathname}" to "${decodedPath}"`);
        setIsRedirecting(true);
        navigate(decodedPath, { replace: true });
        return;
      } catch (e) {
        console.error('[NotFound] Failed to decode URL:', e);
      }
    }
    
    console.error("404 Error: User attempted to access non-existent route:", pathname);
    void logError({
      errorClass: "http_404",
      statusCode: 404,
      route: pathname,
      message: `Route not found: ${pathname}`,
    });
  }, [location.pathname, navigate]);

  if (isRedirecting) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center max-w-md px-6" style={{ fontFamily: "Georgia, serif" }}>
        <h1 className="mb-4 text-4xl font-bold text-foreground">Page not found</h1>
        <p className="mb-2 text-muted-foreground">
          We couldn't find what you were looking for. It has been logged and our team will see it.
        </p>
        <a href="/dashboard" className="text-primary underline hover:text-primary/80">
          Back to dashboard
        </a>
      </div>
    </div>
  );

};

export default NotFound;
